/* src/app/components/kb-layer/universe-component/universe-component.css */
:host {
  display: block;
  padding: 24px;
  color: var(--ink);
  background: transparent;
  font-family: inherit;
}
h1 {
  margin: 0 0 8px;
  font-size: 2rem;
  color: #fbf4df;
}
h2,
h3,
h4 {
  margin: 0 0 10px;
  color: #fbf4df;
}
p {
  margin: 6px 0;
  line-height: 1.5;
  color: var(--ink-soft);
}
strong {
  color: #fff8e8;
}
.toolbar {
  display: flex;
  margin-bottom: 16px;
}
.universes-container {
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-top: 18px;
}
.status-card,
.universe-card,
.section-block,
.item-card,
.sub-block {
  position: relative;
  overflow: hidden;
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow);
}
.status-card::before,
.universe-card::before,
.section-block::before,
.item-card::before,
.sub-block::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background:
    radial-gradient(
      circle at top right,
      rgba(212, 175, 55, 0.08),
      transparent 28%),
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.025),
      transparent 24%);
}
.status-card > *,
.universe-card > *,
.section-block > *,
.item-card > *,
.sub-block > * {
  position: relative;
  z-index: 1;
}
.status-card,
.universe-card {
  background:
    linear-gradient(
      180deg,
      rgba(67, 45, 31, 0.92) 0%,
      rgba(30, 23, 19, 0.96) 100%);
}
.section-block {
  background: rgba(37, 26, 20, 0.92);
}
.item-card {
  background: rgba(18, 13, 11, 0.82);
  margin: 12px 0;
}
.sub-block {
  background: rgba(15, 11, 10, 0.78);
  margin-top: 12px;
}
.status-card {
  padding: 22px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
}
.universe-summary,
.section-block > summary,
.item-card > summary,
.sub-block > summary {
  cursor: pointer;
  list-style: none;
  -webkit-user-select: none;
  user-select: none;
  padding: 16px 18px;
  font-size: 1rem;
  font-weight: 600;
  color: #fbf4df;
  background: rgba(255, 255, 255, 0.04);
  transition: background 0.2s ease;
}
.section-block > summary {
  background: rgba(212, 175, 55, 0.12);
}
.item-card > summary {
  background: rgba(255, 255, 255, 0.03);
}
.sub-block > summary {
  background: rgba(177, 79, 45, 0.14);
}
.universe-summary:hover,
.section-block > summary:hover,
.item-card > summary:hover,
.sub-block > summary:hover {
  background: rgba(212, 175, 55, 0.16);
}
.universe-summary::-webkit-details-marker,
.section-block > summary::-webkit-details-marker,
.item-card > summary::-webkit-details-marker,
.sub-block > summary::-webkit-details-marker {
  display: none;
}
.universe-summary::before,
.section-block > summary::before,
.item-card > summary::before,
.sub-block > summary::before {
  content: "\25b8";
  display: inline-block;
  margin-right: 10px;
  transition: transform 0.2s ease;
  color: var(--gold);
}
details[open] > .universe-summary::before,
details[open] > summary::before {
  transform: rotate(90deg);
}
.universe-content {
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.section-block,
.sub-block {
  margin-top: 8px;
}
.section-block > :not(summary),
.item-card > :not(summary),
.sub-block > :not(summary) {
  padding: 16px 18px;
}
ul {
  margin: 10px 0 0;
  padding-left: 20px;
}
li {
  margin: 6px 0;
  color: #f0e2bc;
}
details + details {
  margin-top: 12px;
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 14px;
}
.form-group label {
  font-weight: 600;
  color: #f3e7c0;
}
.button-row {
  display: flex;
  gap: 10px;
  margin-top: 12px;
  flex-wrap: wrap;
}
.stat-edit-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 100px auto;
  gap: 10px;
  margin: 10px 0;
}
.stat-edit-row input {
  width: 100%;
  box-sizing: border-box;
}
.validation-text {
  margin-top: 10px;
  color: #ffb8a2;
}
@media (max-width: 768px) {
  :host {
    padding: 16px;
  }
  h1 {
    font-size: 1.6rem;
  }
  .universe-summary,
  .section-block > summary,
  .item-card > summary,
  .sub-block > summary {
    padding: 14px;
    font-size: 0.95rem;
  }
  .universe-content,
  .section-block > :not(summary),
  .item-card > :not(summary),
  .sub-block > :not(summary) {
    padding: 14px;
  }
  .stat-edit-row {
    grid-template-columns: 1fr;
  }
}
/*# sourceMappingURL=universe-component.css.map */
